import { Button, Dialog, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import GoogleAccountModal from "../../Components/Modal/GoogleAccountModal";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import Signifier from "../../Components/Signifier";
import GoogleAccountTableCell from "../../Components/Table/GoogleAccountTableCell";
import SortableTable from "../../Components/Table/SortableTable";
import { getGoogleAccounts, getGoogleAccountTypes } from "../../Services/API/GoogleAccount";

function GoogleAccountsPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "60%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    addButton: {
      marginTop: "25px",
      [theme.breakpoints.down("sm")]: {
        marginTop: "0px",
      },
    },
  }));

  const classes = useStyles();

  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [accountTypes, setAccountTypes] = useState([]);
  axios.defaults.headers.common["client"] = "";

  const columns = [
    { label: "Name", propName: "name" },
    { label: "Type", propName: "type" },
    { label: "Number of Configurations", propName: "NumberofConfigurations" },
  ];

  const compare = (a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  const loadAccounts = useCallback(() => {
    setLoading(true);
    setError(false);
    return getGoogleAccountTypes()
      .then((types) => {
        setAccountTypes(types);
        return getGoogleAccounts().then((response) => {
          response.sort((a, b) => {
            const order = compare(a.name, b.name);
            if (order !== 0) return order;
            return a[1] - b[1];
          });
          for (const i in response) {
            response[i].NumberofConfigurations =
              response[i].clientGoogleConfigurationPlacesKeys.length +
              response[i].clientGoogleConfigurationRecaptchaKeys.length;
            response[i].allTypes = types;
            for (const x in types) {
              if (types[x].id === response[i].googleTypeId) {
                response[i].type = types[x].name;
              }
            }
          }
          setData(response);
        });
      })
      .catch((err) => {
        console.error("Failed to load Google accounts:", err);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    loadAccounts();
  }, [loadAccounts]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message="Account Added"
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Google Accounts</h1>
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Button
                color="primary"
                className={classes.addButton}
                style={{ color: "white", marginBottom: "10px" }}
                type="submit"
                variant="contained"
                onClick={() => setOpenModal(true)}
              >
                Add Account
              </Button>
            </Grid>
          </Grid>
          <SortableTable
            columns={columns}
            tableData={data}
            loading={loading}
            error={error}
            onRetry={loadAccounts}
            rowComponent={GoogleAccountTableCell}
          />
        </div>
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <GoogleAccountModal
          openModal={setOpenModal}
          dropdownObjects={accountTypes}
          setData={setData}
          setShowSignifier={setShowSignifier}
          setShowError={setShowError}
        />
      </Dialog>
    </>
  );
}

export default GoogleAccountsPage;
